import enUS from './en-US';
import es from './es';
var localizationMap = new Map([
    ['en-US', enUS],
    ['es', es],
]);
export default localizationMap;
